class LpFbCartLink extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a');
    this.link?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    if (window.Rebuy?.SmartCart?.show) {
      event.preventDefault();
      window.Rebuy.SmartCart.show();
      return;
    }
    if (typeof window.openModal === 'function' && window.matchMedia('(min-width: 990px)').matches) {
      event.preventDefault();
      if (typeof window.fetchCart === 'function') window.fetchCart();
      window.openModal();
    }
    // otherwise fall through to the /cart link
  };
}

if (!customElements.get('lp-fb-cart-link')) {
  customElements.define('lp-fb-cart-link', LpFbCartLink);
}

/* Mobile only: hide the sticky header on scroll down, reveal on scroll up
   so the cart icon stays reachable without permanently eating screen space */
(() => {
  const header = document.querySelector('.lp-fb-header-wrapper');
  if (!header) return;

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const DEADBAND = 8; // px of scroll before toggling, avoids jitter
  let lastY = window.scrollY;
  let ticking = false;

  const update = () => {
    ticking = false;
    const y = window.scrollY;

    if (!mobileQuery.matches || y <= header.offsetHeight) {
      header.classList.remove('lp-fb-header--hidden');
    } else if (y > lastY + DEADBAND) {
      header.classList.add('lp-fb-header--hidden');
    } else if (y < lastY - DEADBAND) {
      header.classList.remove('lp-fb-header--hidden');
    }

    lastY = Math.max(y, 0); // clamp iOS rubber-band negatives
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );

  mobileQuery.addEventListener('change', () => {
    if (!mobileQuery.matches) header.classList.remove('lp-fb-header--hidden');
  });
})();
